module.exports = __webpack_public_path__ + "img/0Q3B7166_Black.67ead491.jpg";